import React from 'react';
export function Hero() {
  return <div className="max-w-3xl mx-auto px-4 py-6" data-id="element-80">
      <div className="text-center mb-6" data-id="element-81">
        <div className="text-sm uppercase font-bold text-gray-500 mb-2" data-id="element-82">
          PET HEALTH
        </div>
        <div className="text-xs text-gray-500 mb-6" data-id="element-83">SPONSORED CONTENT</div>
      </div>

      <h1 className="text-2xl md:text-3xl font-bold text-center mb-4 leading-tight" data-id="element-84">
        The Morning I Found Blood on My Dog's Favorite Toy… And the Discovery
        That Finally Fixed Her Teeth Without Brushing
      </h1>

      <div className="flex items-center justify-center mb-6 text-sm" data-id="element-85">
        <div className="flex items-center" data-id="element-86">
          <div data-id="element-87">
            <p className="font-medium" data-id="element-88">By Sarah Mitchell, Dog Mom & Blogger</p>
            <p className="text-gray-500" data-id="element-89">Updated January 2025</p>
          </div>
        </div>
      </div>

      <div className="bg-gray-100 p-5 rounded-lg mb-8 italic text-center" data-id="element-90">
        <p className="text-lg font-medium" data-id="element-91">
          "My wake-up call came from a chewed-up tennis ball covered in blood."
        </p>
      </div>

      <div className="my-8" data-id="element-92">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tzEt8JFbfid2TgcNkJE2AV/ChatGPT_Image_Dec_1%2C_2025%2C_12_15_38_AM.png" alt="Dog teeth showing tartar buildup and gum disease" className="w-full h-auto rounded-lg shadow-md" data-id="element-93" />
      </div>
    </div>;
}